import { createSlice } from "@reduxjs/toolkit";

const labelledStockSlice = createSlice({
    name:"labelledStocks",
    initialState:{
        labelledStock:null
    },
    reducers:{
        setLabelledList(state,action){
            state.labelledStock = [...(action?.payload)];
        },
    }
})


export const {setLabelledList} = labelledStockSlice.actions
export default labelledStockSlice.reducer